import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f891908"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-error"
}
const _hoisted_3 = {
  key: 0,
  class: "w-full flex flex-row pt-1 space-x-1 items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative", _ctx.floatingInput ? '' : 'floating-input'])
  }, [
    _createVNode(_component_Field, {
      type: _ctx.typeInput,
      name: _ctx.name,
      id: _ctx.name,
      disabled: _ctx.disabled,
      value: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      placeholder: _ctx.placeholder ? _ctx.placeholder : _ctx.name,
      autocomplete: "off",
      class: _normalizeClass([_ctx.custom ? _ctx.customClass : 'input-class border border-gray-100', "focus:outline-none focus:ring-2 focus:ring-black focus:bg-white rounded-xl focus:border-gray-500 focus:shadow-sm w-full p-3 h-16 appearance-none appearance-none transition delay-150 disabled:cursor-not-allowed disabled:opacity-50"])
    }, null, 8, ["type", "name", "id", "disabled", "value", "placeholder", "class"]),
    _createElementVNode("label", {
      for: _ctx.name,
      class: "absolute top-0 left-0 px-3 py-5 h-full pointer-events-none transform origin-left transition-all text-gray-500 duration-100 ease-in-out"
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (Required)"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (!_ctx.custom)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          name: _ctx.name,
          class: "text-sm overflow-ellipsis text-red-500",
          id: "error"
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}